import { useEffect, useState } from 'react';
import TableContent from '../../../components/table-content';
import Button from '../../../components/button';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/delete.svg';
import './ban-list-page.scss';
import Modal from '../../../components/modal';
import { useForm } from 'react-hook-form';
import AppFormInput from '../../../components/form/app-form-input';
import { useSelector } from 'react-redux';
import { AppStore } from '../../../store/store';
import { UserState } from '../../../store/user.slice';
import { apiService } from '../../../services/api.service';
import { errorService } from '../../../services/error.service';


interface BannedUser {
    id: string;
    merchantId: string;
    merchantName: string;
    clientName: string;
    clientEmail: string;
    reason: string;
    createdAt: string;
}



interface Form {
    merchantName: string;
    clientName: string;
    clientEmail: string;
}

export interface CreateBanUser {
    merchantName: string;
    clientName: string;
    clientEmail: string;
}

const BanListPage: React.FC = () => {

    const { user } = useSelector<AppStore, UserState>((state) => state.user);

    const form = useForm<Form>({
        mode: 'onChange',
        defaultValues: {}
    });

    const [bannedUsers, setBannedUsers] = useState<BannedUser[]>();
    const [tableLoader, setTableLoader] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);


    const [showAddModal, setShowAddModal] = useState(false);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteModalData, setDeleteModalData] = useState<BannedUser>();

    useEffect(() => {
        setTableLoader(true)
        apiService.getAllUsersBanList()
            .then(
                (response) => {
                    setBannedUsers(response.data)
                },
                (error) => { }
            ).finally(() => {
                setTableLoader(false)
            })

    }, [user])

    const columnsBanList = [
        {
            Header: 'Merchant Name',
            accessor: 'merchantName',
        },
        {
            Header: 'Client Name',
            accessor: 'clientName',
        },
        {
            Header: 'Client Email',
            accessor: 'clientEmail'
        },
        {
            Header: 'Actions',
            accessor: '',
            Cell: ({ row }: { row: any }) => {
                return (
                    <div>
                        <DeleteIcon
                            className='pointer'
                            onClick={() => {
                                setDeleteModalData(row.original)
                                setShowDeleteModal(true)
                            }}
                        />
                    </div>
                )

            }
        }
    ]


    const onSubmitDeleteUser = async () => {
        setShowDeleteModal(false)
        if (!deleteModalData) return
        try {
            await apiService.removeUserFromBanList(deleteModalData?.id);
            const response = await apiService.getAllUsersBanList();
            setBannedUsers(response.data)
        } catch (e) {
            errorService.showApiError(e)
        } finally {
            setDeleteModalData(undefined)
        }
    }

    const onSubmitAddUser = async () => {
        setShowAddModal(false)
        try {
            const formValues = form.getValues();
            await apiService.addUserToBanList({
                merchantName: formValues.merchantName,
                clientName: formValues.clientName,
                clientEmail: formValues.clientEmail,
            })

            const response = await apiService.getAllUsersBanList();
            setBannedUsers(response.data)
        } catch (e) {
            errorService.showApiError(e)
        } finally {
            form.reset();
        }
    }

    const onDownloadBanList = async () => {
        try {
            setIsDownloading(true);
            const response = await apiService.exportUsersBanList();
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'ban-list.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (e) {
            errorService.showApiError(e);
        } finally {
            setIsDownloading(false);
        }
    }

    return (
        <div className="ban-list-page page-content">
            <div className="page-header flex-row flex-gap-10 flex-align-start-center ">
                <div className='page-title'>
                    Ban List Page
                </div>
            </div>
            <div className='flex-row flex-gap-10'>
                <Button
                    label='Add Ban User'
                    onClick={() => setShowAddModal(true)}
                />
                <Button
                    label='Download Ban List'
                    theme='secondary'
                    onClick={onDownloadBanList}
                    disabled={isDownloading}
                />
            </div>
            <div className='inner-page flex-column flex-gap-30 width-100'>
                <TableContent columns={columnsBanList} data={bannedUsers || []} isLoading={tableLoader} />
            </div>
            {(showDeleteModal && deleteModalData) &&
                <Modal
                    message={`Are you are want to remove user: ${deleteModalData?.clientName}`}
                    onCancel={() => setDeleteModalData(undefined)}
                    onSubmit={onSubmitDeleteUser}
                    showCancelButton
                    buttonText='Confirm'
                >

                </Modal>
            }
            {showAddModal &&
                <Modal
                    message='Add User To Ban List'
                    onCancel={() => setShowAddModal(false)}
                    onSubmit={onSubmitAddUser}
                    showCancelButton
                    buttonText='Add'
                    isDisabled={!form.formState.isValid}
                >
                    <div className='flex-row flex-gap-25'>
                        <AppFormInput
                            control={form.control}
                            name="merchantName"
                            label='Merchant Name'
                            validations={{
                                required: true
                            }}
                        />
                        <AppFormInput
                            control={form.control}
                            name="clientName"
                            label='Client Name'
                            validations={{
                                required: true
                            }}
                        />
                        <AppFormInput
                            control={form.control}
                            name="clientEmail"
                            label="Client Email"
                            validations={{
                                required: true
                            }}
                        />
                    </div>
                </Modal>
            }
        </div>
    )
}

export default BanListPage;